import { render, staticRenderFns } from "./RankingComponent.vue?vue&type=template&id=5d431872"
import script from "./RankingComponent.vue?vue&type=script&lang=js"
export * from "./RankingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports